// extracted by mini-css-extract-plugin
module.exports = {"grid":"ServiceFilterSection_grid__XebPL"};